import React, {memo} from 'react';
import {twMerge} from 'tailwind-merge';

/**
 * DropdownMenuLabel - Non-interactive heading/label inside a DropdownMenuContent.
 *
 * @typedef {Object} DropdownMenuLabelProps
 * @property {React.ReactNode} children - Label content
 * @property {string} [className] - Additional CSS classes
 */
const DropdownMenuLabel = memo(({children, className, ...props}) => {
	return (
		<div
			className={twMerge(
				'px-2 py-1',
				'text-xs font-semibold text-gray-800 dark:text-gray-200',
				className,
			)}
			{...props}
		>
			{children}
		</div>
	);
});

DropdownMenuLabel.displayName = 'DropdownMenuLabel';

export default DropdownMenuLabel;
